import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

/**
 * GET /staff-portal/all — supports ?roleId= and ?active=true|false
 * (Staff model uses `active`, not isActive)
 */
export const getAllStaffPortal = async (filters = {}) => {
  const res = await axiosInstance.get(`/staff-portal/all${qs(filters)}`);
  return res.data;
};

export const getStaffByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/staff-portal/${id}`);
  return res.data;
};
